import * as React from 'react';
import { Form } from 'semantic-ui-react';

interface Props {
    presentaAbono: boolean;
    onChange(presentaAbonoInicial: boolean): void;
}

class PresentaAbonoInicial extends React.PureComponent<Props> {
    public render() {
        const { presentaAbono, onChange } = this.props;

        return (
            <Form.Checkbox
                label='Presenta abono inicial'
                checked={presentaAbono}
                onChange={(_e, { checked }) => {
                    onChange(!!checked);
                }}
            />
        );
    }
}

export default PresentaAbonoInicial;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/componentes/PresentaAbonoInicial.tsx